/* Santa District — pagina Chi siamo: comparsa allo scroll e foto che si avvicina. */
(function () {
  if (window.santaAboutBound) return;
  window.santaAboutBound = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify && window.Shopify.designMode;

  /* --- Comparsa: gli elementi [data-sa-reveal] entrano quando arrivano in vista --- */
  function reveal(root) {
    const items = root.querySelectorAll('[data-sa-reveal]:not(.is-in), .sa-scribble--wait:not(.is-in)');
    if (reduced || designMode || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );
    items.forEach((el) => io.observe(el));
  }

  /* --- Zoom: la foto si avvicina man mano che si scorre la sezione --- */
  const zooms = new Set();
  function registerZooms(root) {
    root.querySelectorAll('[data-sa-zoom]').forEach((el) => zooms.add(el));
    update();
  }
  let ticking = false;
  function update() {
    ticking = false;
    zooms.forEach((el) => {
      if (!el.isConnected) return zooms.delete(el);
      const max = parseFloat(el.dataset.saZoom) || 2.2;
      const rect = el.getBoundingClientRect();
      const stage = el.querySelector('.sa-zoom__stage');
      const span = rect.height - (stage ? stage.offsetHeight : window.innerHeight);
      const progress = span > 0 ? Math.min(1, Math.max(0, -rect.top / span)) : 0;
      const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
      el.style.setProperty('--sa-zoom', reduced ? 1 : (1 + (max - 1) * eased).toFixed(3));
      el.classList.toggle('is-near', progress > 0.55);
    });
  }
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update);

  function init(root) {
    reveal(root);
    registerZooms(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  /* Editor del tema: le sezioni ricaricate vanno reinizializzate */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
